<ycn-modal-base
        [extraModalClasses]="'modal-sm'"
        [open]="isOpen"
        (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
            [header]="metric?.label || ''"
            (closeModalHandler)="closeModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section section-info" *ngIf="this.metric && this.metric.available_asset_types as assetTypes">
            <div class="modal-section-title">Available for:</div>
            <ul><li *ngFor="let assetType of assetTypes" [textContent]="assetType"></li></ul>
        </div>
        <div class="modal-section section-info" *ngIf="glossaryTerm && glossaryTerm.sections as sections">
            <div *ngFor="let section of sections">
                <div class="modal-section-title" *ngIf="section.content" [textContent]="section.header"></div>
                <p [innerHTML]="section.content"></p>
            </div>
        </div>
    </div>
</ycn-modal-base>
